import React from 'react'
import { CLIENT_PAGE_GUTTER } from './CampaignsBrowseParts/clientPageLayout'

export default function ClientTabPlaceholder({ title }) {
  return (
    <div className={`w-full ${CLIENT_PAGE_GUTTER} py-16`}>
      <p className="text-sm font-medium text-rb-lighter-grey dark:text-gray-400">{title} coming soon</p>
    </div>
  )
}
